import { z } from 'zod';
export const DownloadDisposition = z.enum(['inline', 'attachment']);
export const DownloadWatermarkMode = z.enum(['none', 'audit']);
export const CreateSignedDownloadBody = z.object({
    fileId: z.string().uuid(),
    expiresInSeconds: z.number().int().positive().max(60 * 60 * 24 * 7).optional(),
    maxUses: z.number().int().positive().max(100).optional(),
    disposition: DownloadDisposition.optional(),
    watermark: z.boolean().optional(),
});
export const CreateZipJobBody = z
    .object({
    folderId: z.string().uuid().optional(),
    fileIds: z.array(z.string().uuid()).min(1).max(10_000).optional(),
    archiveName: z.string().min(1).max(255).optional(),
    expiresInSeconds: z.number().int().positive().max(60 * 60 * 24 * 14).optional(),
})
    .refine((value) => (value.folderId === undefined) !== (value.fileIds === undefined), {
    message: 'Provide exactly one of folderId or fileIds',
});
export const SignedDownload = z.object({
    id: z.string().uuid(),
    targetKind: z.enum(['file', 'zip_job']),
    fileId: z.string().uuid().nullable(),
    zipJobId: z.string().uuid().nullable(),
    url: z.string(),
    cdnUrl: z.string().url().nullable(),
    expiresAt: z.string().datetime(),
    maxUses: z.number().int().positive(),
    useCount: z.number().int().nonnegative(),
    disposition: DownloadDisposition,
    watermarkMode: DownloadWatermarkMode,
});
export const FileZipJob = z.object({
    id: z.string().uuid(),
    ownerId: z.string().uuid(),
    folderId: z.string().uuid().nullable(),
    sourceKind: z.enum(['folder', 'files']),
    archiveName: z.string(),
    status: z.enum(['queued', 'running', 'completed', 'failed', 'expired']),
    totalFiles: z.number().int().nonnegative(),
    totalBytes: z.number().int().nonnegative(),
    outputSizeBytes: z.number().int().nonnegative().nullable(),
    errorMessage: z.string().nullable(),
    expiresAt: z.string().datetime(),
    startedAt: z.string().datetime().nullable(),
    completedAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const DownloadLog = z.object({
    id: z.string().uuid(),
    tokenId: z.string().uuid().nullable(),
    fileId: z.string().uuid().nullable(),
    zipJobId: z.string().uuid().nullable(),
    targetName: z.string().nullable(),
    source: z.enum(['signed-file', 'signed-zip']),
    success: z.boolean(),
    failureReason: z.string().nullable(),
    bytesServed: z.number().int().nonnegative().nullable(),
    rangeStart: z.number().int().nonnegative().nullable(),
    rangeEnd: z.number().int().nonnegative().nullable(),
    refererHost: z.string().nullable(),
    originHost: z.string().nullable(),
    createdAt: z.string().datetime(),
});
export const SignedDownloadResponse = z.object({ download: SignedDownload });
export const ZipJobResponse = z.object({
    job: FileZipJob,
    download: SignedDownload.nullable(),
});
export const DownloadLogListResponse = z.object({
    logs: z.array(DownloadLog),
    total: z.number().int().nonnegative(),
    limit: z.number().int().nonnegative(),
    offset: z.number().int().nonnegative(),
});
//# sourceMappingURL=downloads.js.map